import * as React from "react";
import LazyLoad from "react-lazyload";

import { UitkCard, UitkCardLink, UitkCardPlaceholder } from "@egds/react-core/cards";
import { UitkFigure, UitkFigureAspectRatioType, UitkImage } from "@egds/react-core/images";
import { UitkScrim } from "@egds/react-core/scrim";
import { UitkText } from "@egds/react-core/text";

import { TrackedLink } from "components/utility/analytics/TrackedLink";
import { MediaAttribution } from "components/utility/MediaAttributionUtil";

import { SimilarDestinationCardProps } from "../typings";

const SimilarDestinationCard = (props: SimilarDestinationCardProps) => {
  const { destination, destinationImageUrl, cardIndex } = props;
  const { media: destinationMedia, link: destinationLink, localisedRegionName: destinationLocalizedName } = destination;
  const attribution = MediaAttribution(destinationMedia, destinationLocalizedName);

  return (
    <LazyLoad offset={500} height="100%" once placeholder={<UitkCardPlaceholder />}>
      <UitkCard>
        <UitkCardLink>
          <TrackedLink
            moduleName="TG.LP"
            rfrr="Dest.OtherPlaces"
            href={destinationLink}
            data-testid={`similar-destinations-${cardIndex}`}
          >
            {destinationLocalizedName}
          </TrackedLink>
        </UitkCardLink>

        <UitkFigure ratio={UitkFigureAspectRatioType.R16_9}>
          <UitkImage alt={attribution.attributionAltText} src={destinationImageUrl} />
          <UitkScrim>
            <UitkText size={600} weight="medium" theme="emphasis">
              {destinationLocalizedName}
            </UitkText>
          </UitkScrim>
          {attribution.attributionText}
        </UitkFigure>
      </UitkCard>
    </LazyLoad>
  );
};

export default SimilarDestinationCard;
